<template>
  <v-dialog v-model="value" max-width="600" persistent>
    <v-form @submit.prevent="submit()" ref="form" :lazy-validation="true" :disabled="isLoading">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between align-center primary white--text py-2"
        >{{ $t('area.add_multiple_stall') }}</v-card-title>
        <v-card-text>
          <v-row class="mt-4">
            <v-col cols="12" class="py-1">
              <span>{{ $t('bill.bill_list') }}</span>
              <v-autocomplete
                v-model="formData.accountingProduct"
                :items="accountingProducts"
                item-text="name"
                item-value="objectId"
                flat
                background-color="grey lighten-4"
                solo
                :label="$t('bill.bill_list')"
                :rules="[rules.required]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="py-1">
              <span>{{ $t('area.space') }}</span>
              <v-autocomplete
                v-model="formData.areas"
                :items="areas"
                item-text="name"
                item-value="objectId"
                solo
                flat
                background-color="grey lighten-4"
                multiple
                :rules="[rules.requiredArray]"
                :label="$t('area.space')"
              >
              <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @mousedown.prevent
                  @click="selectAll"
                >
                  <v-list-item-action>
                    <v-icon :color="formData.areas.length > 0 ? 'primary' : ''">
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('all') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" elevation="0" type="submit" :disabled="isLoading">{{ $t('confirm') }}</v-btn>
          <v-btn color="error" elevation="0" @click="dismiss()" :disabled="isLoading">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    accountingProducts: Array,
    areas: Array
  },
  computed: {
    selectAllArea () {
      return this.formData.areas.length === this.areas.length
    },
    selectSomeArea () {
      return this.formData.areas.length > 0 && !this.selectAllArea
    },
    icon () {
      if (this.selectAllArea) return 'mdi-close-box'
      if (this.selectSomeArea) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
        requiredArray: (value) => !!value.length || this.$t('validate.please_input_data'),
      },
      isLoading: false,
      formData: {
        accountingProduct: null,
        areas: []
      }
    }
  },
  created() {
  },
  watch: {
    value(value) {
      if (value) {
        this.resetForm();
      }
    },
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.formData = {
        accountingProduct: null,
        areas: []
      }
    },
    selectAll(){
      if (this.selectAllArea) {
        this.formData.areas = []
      } else {
        this.formData.areas = this.areas.map(d => d.objectId)
      }
    },
    submit(){
      if (this.$refs.form.validate()) {
        let postData = {
          accountingProduct: null,
          areas: []
        }
        postData.accountingProduct = this.accountingProducts.find(d => d.objectId == this.formData.accountingProduct)
        for(let areaId of this.formData.areas){
          postData.areas.push(this.areas.find(d => d.objectId == areaId))
        }
        this.$emit("onSuccess", postData);
        this.dismiss()
        
      }
    },
  }
}
</script>